import { useEffect } from "react";
import useErrorContext from "../../../../utils/useErrorContext";
import { useDispatch, useSelector } from "react-redux";
import * as CapacitySettings from "./CapacitySettings";
import * as GeneralSettings from './GeneralSettings';
import * as AzureCloudSettings from './AzureCloudSettings';
import { Layout, MainLoader, AccordionCardContent, AccordionTable, AccordionCard, Heading, AccordionController, useAccordionContext, Breadcrumbs } from "@netapp/bxp-design-system-react";
import usePermission from "utils/usePermission";
import { useTranslation } from 'react-i18next';
import { connectorsettings as i18nNamespace } from "../../../../i18n/namespace";
import { Link } from "react-router-dom";
import styles from "./Settings.module.scss";
import { useHistory } from "react-router-dom";

const isLocalDark = process.env.REACT_APP_IS_DARK === "true"


const capacity = {
    section: 'Capacity',
    groups: [CapacitySettings.CapacityManagement, CapacitySettings.AggregateCapacity,
    CapacitySettings.AggregateCapacityDataTiering, CapacitySettings.VolumeAutosize]
};

const general = (darkSiteLocation) => {
    return {
        section: 'General',
        groups: [GeneralSettings.OntapUpdate]
    }
};

const azure = {
    section: 'Azure',
    groups: [AzureCloudSettings.AzureCifs, AzureCloudSettings.AzurePrivateLink]
};

const SettingGroups = ({ optionalItems }) => {
    const { closeAll } = useAccordionContext();
    const hasPermission = usePermission();
    const cvoPermission = hasPermission({
        permissionType: "modify",
        permissionKey: "cvosettings"
    });

    return <div className={styles["setting-group"]}>
        <Heading color="text-title" level={16} className={styles["setting-group-title"]}>
            {optionalItems.section}
        </Heading>
        <AccordionTable isGrouped={true}>
            {optionalItems.groups.map(({ Title, Content }, index) => <AccordionCard isDisabled={!cvoPermission} isExpandDisabled={!cvoPermission} key={index} {...Title()}>
                <AccordionCardContent>
                    <Content close={closeAll} />
                </AccordionCardContent>
            </AccordionCard>)}
        </AccordionTable>
    </div>
}

export default () => {
    const agentId = useSelector(state => state.tenancy.selectedAgentId);
    const dispatch = useDispatch();
    const config = useSelector(state => state.connectorSettings.settings.config);
    const installLocation = useSelector(state => state.app.instancePlacement?.installLocation)?.toLowerCase();
    const darkSiteLocation = isLocalDark ? installLocation : null;
    const { t } = useTranslation(i18nNamespace);
    const history = useHistory();

    if (!agentId) {
        // If a agentId is not specified, redirect to the agents management page
        history.push("/agents-mgmt");
    }

    useEffect(() => {
        dispatch({
            type: "CONNECTOR-SETTINGS:FETCH-CONFIG"
        });
    }, [dispatch, agentId]);
    useErrorContext('CONNECTOR-SETTINGS');

    return <Layout.Page>
        {config ? <Layout.Content>
            <Layout.Container>
                <Breadcrumbs className={styles["breadcrumbs"]}>
                    <Link to="/agents-mgmt">{t("overview")}</Link>
                    <div>{t("cvo_settings")}</div>
                </Breadcrumbs>
                <Heading level="24">{t("edit_cvo_settings")}</Heading>

                <Layout.Grid>
                    <Layout.GridItem lg={12} md={12} sm={12}>
                        <AccordionController>
                            <SettingGroups optionalItems={capacity} />
                            {isLocalDark ? null : <SettingGroups optionalItems={general(darkSiteLocation)} />}
                            {isLocalDark && (darkSiteLocation === 'onprem' || darkSiteLocation === 'aws') ? null : <SettingGroups optionalItems={azure} />}
                        </AccordionController>
                    </Layout.GridItem>
                </Layout.Grid>
            </Layout.Container>
        </Layout.Content>
            : <MainLoader />}
    </Layout.Page>
};